import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/solid';

export default function MarketingCtaBand({
  heading,
  body,
  primaryTo = '/signup',
  primaryLabel = 'Become a member',
  secondaryTo = '/contact',
  secondaryLabel = 'Contact us',
}) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-emerald-700 via-teal-700 to-emerald-800 py-16 sm:py-20">
      <div className="pointer-events-none absolute inset-0 bg-pattern-dots opacity-[0.08]" />
      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="font-serif text-3xl font-bold text-white sm:text-4xl">{heading}</h2>
        {body ? <p className="mt-4 text-lg text-emerald-50/95">{body}</p> : null}
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row sm:gap-4">
          <Link
            to={primaryTo}
            className="inline-flex items-center justify-center rounded-2xl bg-white px-8 py-3.5 text-base font-semibold text-emerald-900 shadow-lg transition hover:bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-emerald-800"
          >
            {primaryLabel}
            <ArrowRightIcon className="ml-2 h-5 w-5" aria-hidden />
          </Link>
          <Link
            to={secondaryTo}
            className="inline-flex items-center justify-center rounded-2xl border-2 border-white/80 bg-transparent px-8 py-3.5 text-base font-semibold text-white transition hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/60 focus:ring-offset-2 focus:ring-offset-emerald-800"
          >
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
